import React, { useState, useCallback, useEffect } from "react";
import { useDragLayer } from 'react-dnd';
import styles from './style.module.scss'
import _ from "lodash";
import cx from "classnames";
import { IKImage } from 'imagekitio-react';

export default function StoryboardCustomDragLayer() {

  const {
    isDragging,
    item,
    initialOffset,
    currentOffset
  } = useDragLayer(monitor => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    currentOffset: monitor.getClientOffset(),
    isDragging: monitor.isDragging()
  }));

  const icon = _.get(item, 'storyboard.page.icon.url');

  if (!isDragging) {
    return null;
  }

  return (
    <div className={styles.dragLayer}>
      <div style={getDragLayerStyles(initialOffset, currentOffset)}>
        <div className={styles.storyboard}>
          <div className={cx(styles.dragImageContainer)}>
            {icon &&
              <IKImage
                className={styles.dragLayerIcon}
                path={icon}
              />
            }
            {!icon &&
              <img className={styles.dragLayerIcon} src={'/images/storyboard.png'} alt="" />
            }
          </div>
          <div className={styles.dragLayerName}>{item.storyboard && item.storyboard.name}</div>
        </div>
      </div>
    </div>
  );

}

function getDragLayerStyles(initialOffset, currentOffset) {
  if (!initialOffset || !currentOffset) {
    return {
      display: "none"
    };
  }

  let { x, y } = currentOffset;

  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform,
    WebkitTransform: transform
  };
}